<template>
  <v-base-card>
    <template v-slot:heading>
      登録・申込フォーム {{typeText}}
    </template>
    <template v-slot:content>
      <p class="env-text mb-2">ブラウザ：Windows→Google Chrome ／ Microsoft Edge (Chromium版)、Mac→Safari（最新版）</p>

      <!-- 申し込み種類 -->
      <v-btn
        color="secondary"
        @click="setFormComponent({ formComponent: 'NewCustomer' })"
        class="ml-3 mr-3"
        small
        >新規申込</v-btn
      >
      <v-btn color="secondary" class="mr-3" small @click="setFormComponent({ formComponent: 'AddClassroom' })"
        >教室追加の申込</v-btn
      >
      <v-btn color="secondary" small @click="setFormComponent({ formComponent: 'CancelClassroom' })"
        >解約申込</v-btn
      >
      <div class="content">
        <keep-alive>
          <component ref="form-component" :is="formComponent"></component>
        </keep-alive>
      </div>

      <!-- 新規・教室追加のチェック項目 -->
      <div class="mt-8 confirm__area" v-if="showConfirm">
        <p class="ml-3 mb-0 confirm__text">以下の内容を確認の上、申し込みます（お申し込みの際には『□』にチェックを入れてください）。</p>
        <v-checkbox
          class="ml-3 mt-0 mb-0"
          v-model="selected"
          value="1"
          hide-details
          dense
          color="secondary"
        >
          <template #[`label`]>
            <p class="confirm__label">下記＜個人情報の取り扱いについて＞に同意のうえ、「ゲットスルー2600」に申し込みます。</p>
          </template>
        </v-checkbox>

        <p class="ml-3 mb-0 mt-4 confirm__text">個人情報の取り扱いについて</p>
        <p class="ml-8 mb-0 confirm__attention">ご入力いただいた個人情報は、本サービスのコンテンツ提供業務（サービス利用規約第6条）のみに利用し、ご本人の同意なく第三者への委託・提供はいたしません。</p>
        <p class="ml-8 mb-0 confirm__attention">個人情報の入力はご本人様の任意ですが、未入力項目があった場合、十分なサービスのご提供ができない場合があります。</p>
        <p class="ml-8 mb-0 confirm__attention">※個人情報の開示及び苦情・相談窓口：株式会社エデュケーショナルネットワーク  個人情報保護管理者（株式会社エデュケーショナルネットワーク  管理部部長）</p>
        <p class="ml-266 confirm__information">電話:03-5275-2103 E-Mail:pms@e-network.jp</p>
      </div>

      <!-- 解約のチェック項目 -->
      <div class="mt-8 confirm__area" v-if="showCancelForm">
        <v-cancel-form class="ml-3" @click-confirm="onClickCancelConfirm"/>
      </div>

      <!-- ボタンら -->
      <div :style="confirmButtonMarginTop">
        <v-btn class="ml-3 mt-4" color="gray" small @click="returnTop">TOPへ戻る</v-btn>
        <v-btn
          v-if="showConfirm"
          class="mt-4 float-right confirm__btn"
          small
          :disabled="selected.length === 0"
          @click="onClickConfirm">
          確認
        </v-btn>
      </div>
    </template>
  </v-base-card>
</template>

<script>
import enrollmentMixin from "@/mixins/enrollment";
import { mapState, mapMutations, mapGetters } from "vuex"

import VBaseCard from '@/components/molecules/BaseCard'
import NewCustomer from '@/components/organizms/NewCustomer'
import AddClassroom from '@/components/organizms/AddClassroom'
import CancelClassroom from '@/components/organizms/CancelClassroom'
import VCancelForm from '@/components/organizms/CancelForm'

export default {
  mixins: [enrollmentMixin],
  components: {
    VBaseCard,
    NewCustomer,
    AddClassroom,
    CancelClassroom,
    VCancelForm
  },
  data() {
    return {
      selected: [],
    }
  },
  watch: {
    formComponent() {
      this.initializeForm({})
      this.checkOperatedDate()
    }
  },
  computed: {
    ...mapState('enrollment', [
      'selectedClassroomIds',
      'hasDuplicatedError'
    ]),
    ...mapGetters('enrollment', [
      'isSearched',
      'isNewCustomer',
      'isAddClassroom',
      'isCancelClassroom',
    ]),
    formComponent() {
      return this.$store.state.enrollment.formComponent
    },
    typeText() {
      let text = ''
      if (this.isNewCustomer) text = '新規'
      else if (this.isAddClassroom) text = '教室追加'
      else if (this.isCancelClassroom) text = '解約'
      return text
    },
    showConfirm() {
      let result = false
      if (this.isNewCustomer) result = true
      else if (this.isAddClassroom && this.isSearched) result = true
      return result
    },
    showCancelForm() {
      return this.isCancelClassroom && this.isSearched
    },
    confirmButtonMarginTop() {
      let marginTop = ''
      if (!this.showConfirm && !this.showCancelForm) {
        marginTop = 'margin-top: 50px'
      } else if (this.showCancelForm) {
        marginTop = 'margin-top: 10px'
      }
      return marginTop
    }
  },
  methods: {
    ...mapMutations('enrollment', [
      'initializeForm',
      'setFormComponent',
      'setCustomerValid',
      'setClassroomValid'
    ]),
    // 新規・教室追加申込の確認が押されたら
    onClickConfirm() {
      const customerValid = this.$refs["form-component"].$refs["customer-form"].validate()
      this.setCustomerValid({ valid: customerValid })

      const classroomValid = this.$refs["form-component"].$refs["classroom-form"].validate()
      this.setClassroomValid({ valid: classroomValid })

      // 顧客情報、教室情報どちらかの入力不備があればトースト表示
      if (!customerValid || !classroomValid) {
        this.$toasted.global.error_eternal({ message: '入力に不備があります。' })
        return
      }

      if (this.hasDuplicatedError) {
        this.$toasted.global.error_eternal({ message: '全ての入力項目が重複している教室が存在します。' })
        return
      }

      if (customerValid && classroomValid) this.$router.push("/enrollment/confirm")
    },
    // 解約申込の確認が押されたら
    onClickCancelConfirm() {
      if (this.isCancelClassroom && this.selectedClassroomIds.length === 0) {
        this.$toasted.global.error_eternal({ message: '解約を行いたい教室を選択してください' })
        return
      }
      this.$router.push('/enrollment/confirm')
    },
  }
}
</script>

<style lang="stylus">
.v-input__slot
  min-height 10px !important
  margin-bottom 0px !important
.v-text-field__details
  background-color #fff1f8 !important
  margin-bottom 0px !important
  padding 4px 3px !important
.text-field
  .v-input__control
    background #fff1f8 !important
    .v-input__slot
      width 220px
      background white !important

</style>

<style lang="stylus" scoped>
.topTitleFrameAdmin
  background #0063AA
  margin-top -15px
  padding-top 5px
  box-shadow 0px 5px 10px rgba(0,0,0,0.4)

.topTitle
  font-size 17px
  color white
  font-weight bold

.confirm
  &__text
    font-size 14px
    font-weight bold

  &__label
    font-size 13px
    height 6px

  &__attention
    font-size 13px

  &__information
    font-size 13px
    margin-left 180px

.checkbox
  font-size 11px

.confirm__btn
  background-color #D65B5B !important
  border-color #D05353 !important
  color white

.env-text
  font-size 14px
  color #646464

.ml-266
  margin-left 266px
</style>
